/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import classnames from 'classnames';

import './SystemNotification.css';

import uiStateSelectors from 'redux/reduxStore/uiState';
import uiStateActions from 'redux/actions/uiState';

import Icons from 'components/images/Icons';
import Checkmark from 'components/images/Checkmark';

function mapStateToProps(state) {
  return {
    isNotificationAvailable: uiStateSelectors.isNotificationAvailable(state),
    message: uiStateSelectors.getNotificationMessage(state),
    color: uiStateSelectors.getNotificationColor(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dismissNotification: () => {
      dispatch(uiStateActions.dismissNotification());
    },
  };
}

const SystemNotification = props => {
  if (!props.isNotificationAvailable) {
    return null;
  }
  const style = {
    text: {},
    container: {},
  };

  return (
    <div className="cmp-notification application-frame-padding">
      <div style={style.text}>
        <FormattedMessage id={props.message} />
      </div>
      <div className="dismiss" onClick={props.dismissNotification}>
        {props.color === 'green'
          ? <IconCheck size={'16'} color={'white'} />
          : <Icons.X />}
      </div>
    </div>
  );
};
SystemNotification.propTypes = {
  color: PropTypes.string,
  message: PropTypes.string,
  dismissNotification: PropTypes.func,
  isNotificationAvailable: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemNotification);
